import { render, staticRenderFns } from "./OwnHouse.vue?vue&type=template&id=4f160085&scoped=true"
import script from "./OwnHouse.vue?vue&type=script&lang=js"
export * from "./OwnHouse.vue?vue&type=script&lang=js"
import style0 from "./OwnHouse.vue?vue&type=style&index=0&id=4f160085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f160085",
  null
  
)

export default component.exports